export const GA_EVENT_PAGE_VIEW = 'ga_pageview';
export const GA_EVENT_IMPRESSION_CLICK = 'eec.impressionClick';
export const GA_EVENT_PROMOTION_VIEW = 'eec.promotionView';
export const GA_EVENT_PROMOTION_CLICK = 'eec.promotionClick';
export const GA_EVENT_CHECKOUT = 'eec.checkout';
export const GA_EVENT_DETAIL = 'eec.detail';
export const GA_EVENT_NATIVE_PROMOTION_CLICK = 'select_content';
export const GA_EVENT_NATIVE_PROMOTION_VIEW = 'view_item';
export const GA_EVENT_TOP_NAVIGATION_CLICK = 'Top navigation click';
export const GA_EVENT_MOBILE_NAVIGATION_CLICK = 'Mobile navigation click';
export const GA_EVENT_LISTING_VIEW = 'listing.view';
export const SP_EVENT_DETAIL = 'sp.detail';
export const SP_EVENT_PAGE_VIEW = 'sp.page_view';
export const SP_EVENT_BANNER_CLICK = 'sp.banner.click';
export const SP_EVENT_BANNER_IMPRESSION = 'sp.banner.impression';
export const SP_EVENT_PRODUCT_CLICK = 'product.click';
export const SP_EVENT_PRODUCT_IMPRESSION = 'product.impression';
export const GA4_EVENT_VIEW_ITEM = 'view_item';
export const GA4_ADD_TO_WISHLIST = 'add_to_wishlist';
export const GA4_EVENT_PROMOTION_VIEW = 'view_promotion';
export const GA4_EVENT_PROMOTION_CLICK = 'select_promotion';
export const GA4_EVENT_VIEW_ITEM_LIST = 'view_item_list';
